// E8/T-064 (v1.8.49, Session 41): "Zahlung erfassen" an der Rechnung (bar oder Überweisung ohne Bankabgleich)
// (reine Funktionen; Regeln wie Business.Zahlung.ZahlungErfassen im Backend)

export type Zahlungsart = 'Bar' | 'Überweisung' | 'PayPal';

export const ZAHLUNG_ERFASSEN_HINWEIS =
  'Für Zahlungen ohne Bankabgleich, z. B. Spesenrechnung bar an Bord bezahlt. Bei vollständiger Zahlung steht die Rechnung auf Bezahlt und die Zahlungsbestätigung geht wie beim Bankabgleich über die Vorlage.';

interface RechnungKurz {
  type?: string | null;
  status?: string | null;
  amountDue?: number | null;
}

/** Ob für die Rechnung eine Zahlung erfasst werden kann (offene Forderung, kein Angebot, Storno, Gutschrift). */
export const zahlungErfassenMoeglich = (r: RechnungKurz): boolean => {
  const typ = (r.type || '').toLowerCase();
  const status = (r.status || '').toLowerCase();
  if (typ === 'angebot' || typ === 'storno' || typ === 'gutschrift') return false;
  if (status === 'cancelled' || status === 'paid') return false;
  return (r.amountDue ?? 0) > 0;
};

/** Deutscher Betrag "1.234,50" oder "23.5" als Zahl; ungültig ergibt NaN. */
export const parseBetrag = (text: string): number => {
  let t = (text || '').replace(/\s|€/g, '');
  if (!t) return NaN;
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  if (!/^-?\d+(\.\d+)?$/.test(t)) return NaN;
  return parseFloat(t);
};

export const betragEingabe = (betrag: number): string => (Math.round(betrag * 100) / 100).toFixed(2).replace('.', ',');

/** Prüft die Eingaben. datum und heute als yyyy-mm-dd. Meldung oder null. */
export const pruefeZahlung = (betragText: string, datum: string, heute: string, art: string): string | null => {
  if (art !== 'Bar' && art !== 'Überweisung' && art !== 'PayPal') return 'Bitte als Zahlungsart "Bar", "Überweisung" oder "PayPal" wählen.';
  const betrag = parseBetrag(betragText);
  if (isNaN(betrag) || betrag <= 0) return 'Bitte einen Betrag größer als 0 angeben.';
  if (Math.round(betrag * 100) / 100 !== betrag) return 'Bitte den Betrag mit höchstens zwei Nachkommastellen angeben.';
  if (!datum) return 'Bitte das Zahlungsdatum angeben.';
  if (datum.slice(0, 10) > heute.slice(0, 10)) return 'Das Zahlungsdatum darf nicht in der Zukunft liegen.';
  return null;
};
